export default __webpack_public_path__ + "static/media/step-2-categories.8e81d44b.png";